// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CrmInstellingenUpdateOfferteDefaultInstellingenAdviseurRequest } from '../model/crmInstellingenUpdateOfferteDefaultInstellingenAdviseurRequest.ts';

import type { CrmInstellingenUpdateOfferteDefaultInstellingenGebruikerRequest } from '../model/crmInstellingenUpdateOfferteDefaultInstellingenGebruikerRequest.ts';

import type { InstellingenHaalOfferteDefaultInstellingenAdviseurOpParams } from '../model/instellingenHaalOfferteDefaultInstellingenAdviseurOpParams.ts';

import type { InstellingenHaalOfferteDefaultInstellingenGebruikerOpParams } from '../model/instellingenHaalOfferteDefaultInstellingenGebruikerOpParams.ts';

import type { InstellingenWerkOfferteDefaultInstellingenAdviseurBijParams } from '../model/instellingenWerkOfferteDefaultInstellingenAdviseurBijParams.ts';

import type { InstellingenWerkOfferteDefaultInstellingenGebruikerBijParams } from '../model/instellingenWerkOfferteDefaultInstellingenGebruikerBijParams.ts';

import type { MicrosoftAspNetCoreHttpHttpValidationProblemDetails } from '../model/microsoftAspNetCoreHttpHttpValidationProblemDetails.ts';

import type { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails.ts';

import type { Result1OfCrmInstellingenGetOfferteDefaultInstellingenAdviseurResponse } from '../model/result1OfCrmInstellingenGetOfferteDefaultInstellingenAdviseurResponse.ts';

import type { Result1OfCrmInstellingenGetOfferteDefaultInstellingenGebruikerResponse } from '../model/result1OfCrmInstellingenGetOfferteDefaultInstellingenGebruikerResponse.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.AdviseurInzien</li></ul>
 * @summary haalt offertedefault-instellingen voor adviseur op.
 */
export const instellingenHaalOfferteDefaultInstellingenAdviseurOp = (
  params?: MaybeRefOrGetter<InstellingenHaalOfferteDefaultInstellingenAdviseurOpParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<Result1OfCrmInstellingenGetOfferteDefaultInstellingenAdviseurResponse>(
    { url: `/api/v1/instellingen/offerte-defaults-adviseur`, method: 'GET', params, signal },
    options,
  );
};

export const getInstellingenHaalOfferteDefaultInstellingenAdviseurOpQueryKey = (
  params?: MaybeRefOrGetter<InstellingenHaalOfferteDefaultInstellingenAdviseurOpParams>,
) => {
  return [
    'api',
    'v1',
    'instellingen',
    'offerte-defaults-adviseur',
    ...(params ? [params] : []),
  ] as const;
};

export const getInstellingenHaalOfferteDefaultInstellingenAdviseurOpQueryOptions = <
  TData = Awaited<ReturnType<typeof instellingenHaalOfferteDefaultInstellingenAdviseurOp>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  params?: MaybeRefOrGetter<InstellingenHaalOfferteDefaultInstellingenAdviseurOpParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof instellingenHaalOfferteDefaultInstellingenAdviseurOp>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getInstellingenHaalOfferteDefaultInstellingenAdviseurOpQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof instellingenHaalOfferteDefaultInstellingenAdviseurOp>>
  > = ({ signal }) =>
    instellingenHaalOfferteDefaultInstellingenAdviseurOp(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof instellingenHaalOfferteDefaultInstellingenAdviseurOp>>,
    TError,
    TData
  >;
};

export type InstellingenHaalOfferteDefaultInstellingenAdviseurOpQueryResult = NonNullable<
  Awaited<ReturnType<typeof instellingenHaalOfferteDefaultInstellingenAdviseurOp>>
>;
export type InstellingenHaalOfferteDefaultInstellingenAdviseurOpQueryError = ErrorType<
  void | MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;

/**
 * @summary haalt offertedefault-instellingen voor adviseur op.
 */

export function useInstellingenHaalOfferteDefaultInstellingenAdviseurOp<
  TData = Awaited<ReturnType<typeof instellingenHaalOfferteDefaultInstellingenAdviseurOp>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  params?: MaybeRefOrGetter<InstellingenHaalOfferteDefaultInstellingenAdviseurOpParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof instellingenHaalOfferteDefaultInstellingenAdviseurOp>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getInstellingenHaalOfferteDefaultInstellingenAdviseurOpQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.AdviseurInzien</li></ul>
 * @summary Werkt offertedefault-instellingen van adviseur bij.
 */
export const instellingenWerkOfferteDefaultInstellingenAdviseurBij = (
  crmInstellingenUpdateOfferteDefaultInstellingenAdviseurRequest?: MaybeRefOrGetter<CrmInstellingenUpdateOfferteDefaultInstellingenAdviseurRequest>,
  params?: MaybeRefOrGetter<InstellingenWerkOfferteDefaultInstellingenAdviseurBijParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  crmInstellingenUpdateOfferteDefaultInstellingenAdviseurRequest = toValue(
    crmInstellingenUpdateOfferteDefaultInstellingenAdviseurRequest,
  );
  params = toValue(params);

  return customInstance<void>(
    {
      url: `/api/v1/instellingen/offerte-defaults-adviseur`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmInstellingenUpdateOfferteDefaultInstellingenAdviseurRequest,
      params,
      signal,
    },
    options,
  );
};

export const getInstellingenWerkOfferteDefaultInstellingenAdviseurBijMutationOptions = <
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof instellingenWerkOfferteDefaultInstellingenAdviseurBij>>,
    TError,
    InstellingenWerkOfferteDefaultInstellingenAdviseurBijMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof instellingenWerkOfferteDefaultInstellingenAdviseurBij>>,
  TError,
  InstellingenWerkOfferteDefaultInstellingenAdviseurBijMutationVariables,
  TContext
> => {
  const mutationKey = ['instellingenWerkOfferteDefaultInstellingenAdviseurBij'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof instellingenWerkOfferteDefaultInstellingenAdviseurBij>>,
    InstellingenWerkOfferteDefaultInstellingenAdviseurBijMutationVariables
  > = (props) => {
    const { data, params } = props ?? {};

    return instellingenWerkOfferteDefaultInstellingenAdviseurBij(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InstellingenWerkOfferteDefaultInstellingenAdviseurBijMutationResult = NonNullable<
  Awaited<ReturnType<typeof instellingenWerkOfferteDefaultInstellingenAdviseurBij>>
>;
export type InstellingenWerkOfferteDefaultInstellingenAdviseurBijMutationBody =
  | CrmInstellingenUpdateOfferteDefaultInstellingenAdviseurRequest
  | undefined;
export type InstellingenWerkOfferteDefaultInstellingenAdviseurBijMutationError = ErrorType<
  void | MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;
export type InstellingenWerkOfferteDefaultInstellingenAdviseurBijMutationVariables = {
  data?: CrmInstellingenUpdateOfferteDefaultInstellingenAdviseurRequest;
  params?: InstellingenWerkOfferteDefaultInstellingenAdviseurBijParams;
};

/**
 * @summary Werkt offertedefault-instellingen van adviseur bij.
 */
export const useInstellingenWerkOfferteDefaultInstellingenAdviseurBij = <
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof instellingenWerkOfferteDefaultInstellingenAdviseurBij>>,
      TError,
      InstellingenWerkOfferteDefaultInstellingenAdviseurBijMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof instellingenWerkOfferteDefaultInstellingenAdviseurBij>>,
  TError,
  InstellingenWerkOfferteDefaultInstellingenAdviseurBijMutationVariables,
  TContext
> => {
  return useMutation(
    getInstellingenWerkOfferteDefaultInstellingenAdviseurBijMutationOptions(options),
    queryClient,
  );
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
 * @summary haalt offertedefault-instellingen van gebruiker op.
 */
export const instellingenHaalOfferteDefaultInstellingenGebruikerOp = (
  params?: MaybeRefOrGetter<InstellingenHaalOfferteDefaultInstellingenGebruikerOpParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<Result1OfCrmInstellingenGetOfferteDefaultInstellingenGebruikerResponse>(
    { url: `/api/v1/instellingen/offerte-defaults-gebruiker`, method: 'GET', params, signal },
    options,
  );
};

export const getInstellingenHaalOfferteDefaultInstellingenGebruikerOpQueryKey = (
  params?: MaybeRefOrGetter<InstellingenHaalOfferteDefaultInstellingenGebruikerOpParams>,
) => {
  return [
    'api',
    'v1',
    'instellingen',
    'offerte-defaults-gebruiker',
    ...(params ? [params] : []),
  ] as const;
};

export const getInstellingenHaalOfferteDefaultInstellingenGebruikerOpQueryOptions = <
  TData = Awaited<ReturnType<typeof instellingenHaalOfferteDefaultInstellingenGebruikerOp>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  params?: MaybeRefOrGetter<InstellingenHaalOfferteDefaultInstellingenGebruikerOpParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof instellingenHaalOfferteDefaultInstellingenGebruikerOp>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getInstellingenHaalOfferteDefaultInstellingenGebruikerOpQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof instellingenHaalOfferteDefaultInstellingenGebruikerOp>>
  > = ({ signal }) =>
    instellingenHaalOfferteDefaultInstellingenGebruikerOp(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof instellingenHaalOfferteDefaultInstellingenGebruikerOp>>,
    TError,
    TData
  >;
};

export type InstellingenHaalOfferteDefaultInstellingenGebruikerOpQueryResult = NonNullable<
  Awaited<ReturnType<typeof instellingenHaalOfferteDefaultInstellingenGebruikerOp>>
>;
export type InstellingenHaalOfferteDefaultInstellingenGebruikerOpQueryError = ErrorType<
  void | MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;

/**
 * @summary haalt offertedefault-instellingen van gebruiker op.
 */

export function useInstellingenHaalOfferteDefaultInstellingenGebruikerOp<
  TData = Awaited<ReturnType<typeof instellingenHaalOfferteDefaultInstellingenGebruikerOp>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  params?: MaybeRefOrGetter<InstellingenHaalOfferteDefaultInstellingenGebruikerOpParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof instellingenHaalOfferteDefaultInstellingenGebruikerOp>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getInstellingenHaalOfferteDefaultInstellingenGebruikerOpQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
 * @summary Werkt offertedefault-instellingen van gebruiker bij.
 */
export const instellingenWerkOfferteDefaultInstellingenGebruikerBij = (
  crmInstellingenUpdateOfferteDefaultInstellingenGebruikerRequest?: MaybeRefOrGetter<CrmInstellingenUpdateOfferteDefaultInstellingenGebruikerRequest>,
  params?: MaybeRefOrGetter<InstellingenWerkOfferteDefaultInstellingenGebruikerBijParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  crmInstellingenUpdateOfferteDefaultInstellingenGebruikerRequest = toValue(
    crmInstellingenUpdateOfferteDefaultInstellingenGebruikerRequest,
  );
  params = toValue(params);

  return customInstance<void>(
    {
      url: `/api/v1/instellingen/offerte-defaults-gebruiker`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmInstellingenUpdateOfferteDefaultInstellingenGebruikerRequest,
      params,
      signal,
    },
    options,
  );
};

export const getInstellingenWerkOfferteDefaultInstellingenGebruikerBijMutationOptions = <
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof instellingenWerkOfferteDefaultInstellingenGebruikerBij>>,
    TError,
    InstellingenWerkOfferteDefaultInstellingenGebruikerBijMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof instellingenWerkOfferteDefaultInstellingenGebruikerBij>>,
  TError,
  InstellingenWerkOfferteDefaultInstellingenGebruikerBijMutationVariables,
  TContext
> => {
  const mutationKey = ['instellingenWerkOfferteDefaultInstellingenGebruikerBij'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof instellingenWerkOfferteDefaultInstellingenGebruikerBij>>,
    InstellingenWerkOfferteDefaultInstellingenGebruikerBijMutationVariables
  > = (props) => {
    const { data, params } = props ?? {};

    return instellingenWerkOfferteDefaultInstellingenGebruikerBij(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InstellingenWerkOfferteDefaultInstellingenGebruikerBijMutationResult = NonNullable<
  Awaited<ReturnType<typeof instellingenWerkOfferteDefaultInstellingenGebruikerBij>>
>;
export type InstellingenWerkOfferteDefaultInstellingenGebruikerBijMutationBody =
  | CrmInstellingenUpdateOfferteDefaultInstellingenGebruikerRequest
  | undefined;
export type InstellingenWerkOfferteDefaultInstellingenGebruikerBijMutationError = ErrorType<
  void | MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;
export type InstellingenWerkOfferteDefaultInstellingenGebruikerBijMutationVariables = {
  data?: CrmInstellingenUpdateOfferteDefaultInstellingenGebruikerRequest;
  params?: InstellingenWerkOfferteDefaultInstellingenGebruikerBijParams;
};

/**
 * @summary Werkt offertedefault-instellingen van gebruiker bij.
 */
export const useInstellingenWerkOfferteDefaultInstellingenGebruikerBij = <
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof instellingenWerkOfferteDefaultInstellingenGebruikerBij>>,
      TError,
      InstellingenWerkOfferteDefaultInstellingenGebruikerBijMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof instellingenWerkOfferteDefaultInstellingenGebruikerBij>>,
  TError,
  InstellingenWerkOfferteDefaultInstellingenGebruikerBijMutationVariables,
  TContext
> => {
  return useMutation(
    getInstellingenWerkOfferteDefaultInstellingenGebruikerBijMutationOptions(options),
    queryClient,
  );
};
